import React from "react";

import * as Sticker from "ds/Sticker";
import useDecodedParams from "Hooks/useDecodedParams";
import { useLoadEnvironmentVariables } from "Reducers/environment/settings/variable/hooks/useLoadEnvironmentVariables";
import { useLoadVariables } from "Reducers/project/settings/variable/hooks/useLoadVariables";

import MultipleEnvironments from "./MultipleEnvironments";
import SingleEnvironment from "./SingleEnvironment";
import {
  blackfireProjectVariable,
  mainOnlyEnvironment,
  blackfireEnvironmentVariablesFilter
} from "./utils";

const StickerBlackfire = () => {
  const {
    organizationId,
    projectId
  }: { organizationId: string; projectId: string } = useDecodedParams();

  const { variables: projectVariables } = useLoadVariables({
    organizationId,
    projectId
  });

  const { multipleEnvironments } = useLoadEnvironmentVariables({
    organizationId,
    projectId
  });

  const blackfireEnviromentVariables =
    blackfireEnvironmentVariablesFilter(multipleEnvironments);

  const isBlackfireProjectVariable = blackfireProjectVariable(projectVariables);

  const isMainTheOnlyEnvironment = mainOnlyEnvironment(
    blackfireEnviromentVariables
  );

  const hasMultipleEnvironments =
    blackfireEnviromentVariables?.length > 0 &&
    (isBlackfireProjectVariable || !isMainTheOnlyEnvironment);

  const isBlackfire =
    isBlackfireProjectVariable || blackfireEnviromentVariables?.length > 0;

  return isBlackfire ? (
    <Sticker.Root priority="normal" css={{ marginBottom: 24 }}>
      <Sticker.Icon priority="normal" />
      <Sticker.Text>
        {hasMultipleEnvironments ? (
          <MultipleEnvironments
            isBlackfireProjectVariable={isBlackfireProjectVariable}
            blackfireEnviromentVariables={blackfireEnviromentVariables}
            projectVariables={projectVariables}
          />
        ) : (
          <SingleEnvironment
            isBlackfireProjectVariable={isBlackfireProjectVariable}
          />
        )}
      </Sticker.Text>
    </Sticker.Root>
  ) : null;
};

export default StickerBlackfire;
